export default {
  FETCH_DATA: 'depot_cont_fetch_data',
  UPDATE_QUERY: 'depot_cont_update_query',
  LOAD_MORE_DATA: 'depot_cont_load_more_data',
  UPDATE_LOADING: 'depot_cont_update_loading',
  UPDATE_SELECTED: 'depot_cont_update_selected',
};
